import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import JsonLd, { quizSchema } from '../components/JsonLd';

const questionPool = [
  { question: 'What is a stock?', options: ['A loan to a company', 'A share of ownership in a company', 'A type of bond', 'A savings account'], correct: 1 },
  { question: 'What does market capitalisation refer to?', options: ['The total value of a company\'s outstanding shares', 'The maximum amount a stock can increase in one day', 'The total debt of a company', 'The number of employees in a company'], correct: 0 },
  { question: 'What is an IPO?', options: ['International Payment Option', 'Investor Protection Organization', 'Initial Public Offering', 'Institutional Purchase Order'], correct: 2 },
  { question: 'Which stock exchange is known for listing technology companies?', options: ['NYSE', 'NASDAQ', 'LSE', 'TSE'], correct: 1 },
  { question: 'What is a bear market?', options: ['A market where prices are falling', 'A market where prices are rising', 'A market that\'s closed', 'A market for commodities'], correct: 0 },
  { question: 'What is a bull market?', options: ['A market where prices are falling', 'A market where prices are rising', 'A market that\'s closed', 'A market for livestock'], correct: 1 },
  { question: 'Companies with a market cap over $10 billion are classified as:', options: ['Small-cap', 'Mid-cap', 'Large-cap', 'Mega-cap'], correct: 2 },
  { question: 'What is the S&P 500?', options: ['A stock trading at $500 per share', 'An index of 500 large U.S. companies', 'A tax form for investors', 'A type of retirement account'], correct: 1 },
  { question: 'What does diversification mean?', options: ['Putting all money in one stock', 'Spreading investments across different assets', 'Only buying expensive stocks', 'Trading frequently'], correct: 1 },
  { question: 'What is an ETF?', options: ['Electronic Trading Fund', 'Exchange-Traded Fund', 'Equity Trust Factor', 'Extended Tax Form'], correct: 1 },
  { question: 'What is dollar-cost averaging?', options: ['Converting foreign currencies to dollars', 'Investing a fixed amount at regular intervals regardless of price', 'Buying stocks only when the dollar is strong', 'Calculating the average cost of all your investments'], correct: 1 },
  { question: 'Which account type offers tax-free growth and withdrawals in retirement?', options: ['Traditional IRA', '401(k)', 'Roth IRA', 'Standard brokerage account'], correct: 2 },
  { question: 'What does the expense ratio of a fund represent?', options: ['The percentage of your investment that goes to fees annually', 'The ratio of stocks to bonds in the fund', 'The percentage of profitable companies in the fund', 'The fund\'s performance vs its benchmark'], correct: 0 },
  { question: 'What does ESG investing focus on?', options: ['Eastern and Southern Global markets', 'Extremely Stable Growth companies', 'Environmental, Social, and Governance factors', 'Equity, Securities, and Guarantees'], correct: 2 },
  { question: 'What is the Rule of 72 used for?', options: ['Calculating tax deductions', 'Estimating how long it takes for an investment to double', 'Determining the maximum portfolio allocation for one stock', 'Setting the retirement age'], correct: 1 },
  { question: 'What is a limit order?', options: ['An order to buy or sell at the current market price', 'An order to buy or sell at a specific price or better', 'An order that limits the number of shares you can buy', 'An order that expires at end of day'], correct: 1 },
  { question: 'What is a stop-loss order designed to do?', options: ['Guarantee profits on a trade', 'Prevent buying overpriced stocks', 'Limit potential losses on a position', 'Stop trading for the day after a loss'], correct: 2 },
  { question: 'What trading style involves opening and closing positions within the same day?', options: ['Swing trading', 'Position trading', 'Day trading', 'Scalping'], correct: 2 },
  { question: 'What does FOMO stand for in trading psychology?', options: ['Focus On Market Opportunities', 'Fear Of Missing Out', 'Finding Optimal Market Openings', 'Fundamental Oversight of Market Operations'], correct: 1 },
  { question: 'What does high trading volume typically indicate?', options: ['Low interest in a security', 'Significant interest and liquidity in a security', 'The market is closed', 'The stock will definitely increase in value'], correct: 1 },
  { question: 'What is systematic risk?', options: ['Risk affecting a specific company', 'Risk that affects the entire market', 'Risk that can be completely eliminated', 'Risk that only affects active traders'], correct: 1 },
  { question: 'What is position sizing?', options: ['The physical size of a trading desk', 'Determining how much of your portfolio to allocate to each investment', 'The number of positions you hold', 'The size of a company\'s market position'], correct: 1 },
  { question: 'What does a correlation of −1.0 between two assets indicate?', options: ['They move in the same direction', 'They move in opposite directions', 'They have no relationship', 'One will always outperform the other'], correct: 1 },
  { question: 'What does the P/E ratio stand for?', options: ['Price to Earnings', 'Profit to Expense', 'Performance to Expectation', 'Potential to Earnings'], correct: 0 },
  { question: 'What is the RSI indicator used for?', options: ['Measuring company revenue', 'Identifying overbought or oversold conditions', 'Calculating dividend yields', 'Determining market capitalisation'], correct: 1 },
  { question: 'What is the VIX often called?', options: ['Victory Index', 'Volatility Indicator X', 'Fear Index', 'Value Investment Xchange'], correct: 2 },
  { question: 'What does a yield curve inversion historically signal?', options: ['Bull market ahead', 'Potential recession ahead', 'Stable interest rates', 'Increased dividend payments'], correct: 1 },
  { question: 'Which is a leading economic indicator?', options: ['Unemployment rate', 'GDP', 'Building permits', 'Corporate profits'], correct: 2 },
  { question: 'What is fundamental analysis primarily concerned with?', options: ['Chart patterns and price movements', 'Market sentiment and psychology', 'A company\'s intrinsic value based on financial data', 'Trading volume and liquidity'], correct: 2 },
  { question: 'What is a "golden cross" in technical analysis?', options: ['A religious symbol used by traders', 'When a short-term moving average crosses above a long-term moving average', 'The intersection of support and resistance lines', 'The highest point a stock reaches before declining'], correct: 1 },
  { question: 'What does MACD stand for?', options: ['Multiple Average Calculation Derivative', 'Market Analysis and Chart Direction', 'Moving Average Convergence Divergence', 'Maximum Achievable Capital Distribution'], correct: 2 },
  { question: 'What is market breadth?', options: ['The width of a stock chart', 'A measure of the number of stocks participating in a market move', 'The total number of shares traded in a day', 'The range between a stock\'s 52-week high and low'], correct: 1 },
  { question: 'What is a trailing stop?', options: ['Follows behind market trends', 'Moves up as the price of the security increases', 'Stops trading after a certain profit percentage', 'Trails the performance of a benchmark index'], correct: 1 },
  { question: 'What is hedging in investment terms?', options: ['Trimming your spending', 'Avoiding investment decisions', 'Taking offsetting positions to reduce risk exposure', 'Investing only in hedge funds'], correct: 2 },
  { question: 'What is rebalancing a portfolio?', options: ['Selling all your investments and starting over', 'Realigning your asset mix back to your target allocation', 'Balancing wins and losses equally', 'Switching to a different broker'], correct: 1 },
  { question: 'What does liquidity mean in investing?', options: ['How much cash you have', 'How easily an asset can be bought or sold without moving its price', 'The amount of debt a company has', 'The volatility of an investment'], correct: 1 },
  { question: 'What is the Sharpe ratio used for?', options: ['Measuring total portfolio value', 'Measuring risk-adjusted return', 'Calculating tax liability', 'Estimating future earnings'], correct: 1 },
  { question: 'What is paper trading?', options: ['Trading physical commodities like paper', 'Simulated trading without real money to practice strategies', 'Printing trading records', 'Trading bonds and notes'], correct: 1 },
  { question: 'What does "dollar-cost averaging" protect against?', options: ['Company bankruptcy', 'The risk of investing a large sum at exactly the wrong time', 'Dividend cuts', 'Currency risk'], correct: 1 },
  { question: 'Which of these is generally considered the safest investment?', options: ['Small-cap stocks', 'Cryptocurrency', 'U.S. Treasury bonds', 'Penny stocks'], correct: 2 },
  { question: 'What is sector rotation?', options: ['Changing your broker', 'Moving capital between industry sectors as the economic cycle progresses', 'Rotating which stocks you monitor', 'A type of options strategy'], correct: 1 },
  { question: 'What does compound interest mean?', options: ['Interest on the initial investment only', 'Interest calculated on both principal and accumulated interest', 'Multiple sources of interest income', 'Complex interest rate calculations'], correct: 1 },
  { question: 'What is an expense ratio?', options: ['How much a company spends on operations', 'An annual fee charged by a fund as a % of assets', 'The ratio of expenses to income', 'A measure of portfolio performance'], correct: 1 },
  { question: 'What is the maximum drawdown?', options: ['Maximum amount you can withdraw per day', 'The largest peak-to-trough decline in portfolio value', 'Maximum position size allowed by a broker', 'The maximum loss in a single trade'], correct: 1 },
  { question: 'What is a Roth IRA?', options: ['A trading account with no taxes', 'A retirement account with after-tax contributions and tax-free withdrawals', 'A type of ETF', 'A government bond'], correct: 1 },
  { question: 'What is ROE?', options: ['Rate of Exchange', 'Return on Equity — net income divided by shareholder equity', 'Risk of Exposure', 'Rate of Earnings'], correct: 1 },
  { question: 'What does EPS stand for?', options: ['Expected Price of Stock', 'Earnings Per Share', 'Equity Position Size', 'Exchange Pricing Standard'], correct: 1 },
  { question: 'What is a moving average used for in technical analysis?', options: ['Calculating average portfolio gains', 'Smoothing price data to identify trends', 'Averaging the cost basis of your investments', 'Measuring average trading volume'], correct: 1 },
  { question: 'What is a short squeeze?', options: ['A brief market downturn', 'When short sellers are forced to buy shares rapidly, driving the price up sharply', 'Squeezing profits from short trades', 'A regulatory action against short selling'], correct: 1 },
  { question: 'What does fractional share investing allow you to do?', options: ['Buy stocks in fractions of a country', 'Purchase a portion of a single share with a small amount of money', 'Trade partial days', 'Divide profits among multiple investors'], correct: 1 },
];

const QUESTIONS_PER_QUIZ = 10;

const Quiz = () => {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);

  const initQuiz = () => {
    const shuffled = [...questionPool].sort(() => Math.random() - 0.5);
    setQuestions(shuffled.slice(0, QUESTIONS_PER_QUIZ));
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setDone(false);
  };

  useEffect(() => { initQuiz(); }, []);

  const handleSelect = (idx) => {
    if (selected !== null) return;
    setSelected(idx);
  };

  const handleNext = () => {
    const isCorrect = selected === questions[current].correct;
    const newScore = isCorrect ? score + 1 : score;
    if (current + 1 >= questions.length) {
      setScore(newScore);
      setDone(true);
    } else {
      setScore(newScore);
      setCurrent(current + 1);
      setSelected(null);
    }
  };

  const pct = Math.round((score / questions.length) * 100);

  const resultMessage = () => {
    if (score === questions.length) return 'Perfect score! You know your stuff.';
    if (score >= questions.length * 0.8) return 'Great work — you\'re on the right track.';
    if (score >= questions.length * 0.5) return 'Good effort. Review the topics you missed and try again.';
    return 'Keep studying — the content pages will help fill in the gaps.';
  };

  if (!questions.length) return null;

  return (
    <>
      <SEO
        title="Stock Market Knowledge Quiz - Test Your Investing Knowledge | StckFuture"
        description="Test your stock market knowledge with our free investing quiz. Questions cover fundamentals, trading principles, risk management, and market analysis."
        canonical="https://www.stckfuture.com/quiz"
      />
      <JsonLd schema={quizSchema} />
      <div className="sf-content-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mx-auto">

              <div className="sf-page-header">
                <span className="sf-eyebrow">Knowledge check</span>
                <h1>Quiz</h1>
                <p className="lead">{QUESTIONS_PER_QUIZ} questions drawn randomly from our full question bank. A new set each time.</p>
              </div>

              {done ? (
                /* ── Results screen ── */
                <div className="sf-quiz-card text-center">
                  <div style={{ marginBottom: 24 }}>
                    <div style={{
                      width: 72, height: 72, borderRadius: '50%',
                      background: score >= questions.length * 0.7 ? 'var(--green-light)' : 'var(--off-white)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 16px', fontSize: '1.75rem',
                    }}>
                      {score === questions.length ? '🎯' : score >= questions.length * 0.7 ? '✅' : '📖'}
                    </div>
                    <h2 style={{ fontSize: '1.375rem', fontWeight: 700, marginBottom: 4 }}>
                      {score} / {questions.length}
                    </h2>
                    <p className="sf-text-muted" style={{ marginBottom: 20 }}>{resultMessage()}</p>
                  </div>

                  {/* Score bar */}
                  <div style={{ background: 'var(--border)', borderRadius: 4, height: 8, marginBottom: 28 }}>
                    <div style={{
                      height: '100%', borderRadius: 4,
                      width: `${pct}%`,
                      background: pct >= 80 ? 'var(--green)' : pct >= 50 ? '#f59e0b' : '#ef4444',
                      transition: 'width 0.5s ease',
                    }} />
                  </div>

                  <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button className="btn-sf-primary" onClick={initQuiz}>
                      Try again with new questions
                    </button>
                    <Link to="/" className="btn-sf-outline">Back to home</Link>
                  </div>
                </div>
              ) : (
                /* ── Question screen ── */
                <div className="sf-quiz-card">
                  <div className="sf-quiz-meta">
                    <span className="sf-quiz-badge">
                      Question {current + 1} of {questions.length}
                    </span>
                    <div className="sf-progress">
                      <div
                        className="sf-progress-fill"
                        style={{ width: `${((current + 1) / questions.length) * 100}%` }}
                      />
                    </div>
                  </div>

                  <p className="sf-quiz-question">{questions[current].question}</p>

                  <div className="sf-quiz-options">
                    {questions[current].options.map((opt, idx) => {
                      let extraStyle = {};
                      if (selected !== null) {
                        if (idx === questions[current].correct) {
                          extraStyle = { borderColor: 'var(--green)', background: 'var(--green-light)', color: 'var(--green-dark)' };
                        } else if (idx === selected && selected !== questions[current].correct) {
                          extraStyle = { borderColor: '#ef4444', background: '#fef2f2', color: '#b91c1c' };
                        }
                      }
                      return (
                        <button
                          key={idx}
                          className={`sf-quiz-option ${selected === idx ? 'selected' : ''}`}
                          style={selected !== null ? extraStyle : {}}
                          onClick={() => handleSelect(idx)}
                          disabled={selected !== null}
                        >
                          <div className={`sf-quiz-dot ${selected === idx ? 'filled' : ''}`} />
                          {opt}
                        </button>
                      );
                    })}
                  </div>

                  {/* Feedback */}
                  {selected !== null && (
                    <div style={{
                      marginTop: 16,
                      padding: '10px 14px',
                      borderRadius: 'var(--radius)',
                      background: selected === questions[current].correct ? 'var(--green-light)' : '#fef2f2',
                      color: selected === questions[current].correct ? 'var(--green-dark)' : '#b91c1c',
                      fontSize: '0.875rem',
                      fontWeight: 500,
                    }}>
                      {selected === questions[current].correct
                        ? '✓ Correct!'
                        : `✗ The correct answer is: ${questions[current].options[questions[current].correct]}`}
                    </div>
                  )}

                  <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                      className="btn-sf-primary"
                      onClick={handleNext}
                      disabled={selected === null}
                      style={{ opacity: selected === null ? 0.5 : 1 }}
                    >
                      {current === questions.length - 1 ? 'See results' : 'Next question →'}
                    </button>
                  </div>
                </div>
              )}

              <div className="text-center mt-4">
                <Link to="/" className="sf-text-muted sf-text-small">← Back to home</Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quiz;